<app-stage-form [stage]="stage$ | async" [stages]="stages$ | async" [states]="states$ | async"
    [loading]="loading$ | async" [statesSubtype]="statesSubtype$ | async" (saveState$)="onSaveState($event)"
    (deleteState$)="onDeleteState($event)" (deleteStage$)="onDeleteStage($event)"
    (updateStage$)="onUpdateStage($event)">
</app-stage-form>